var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTcsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#007DC5;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_00000089567102041280888380000009130618068464374965_);}\r\n\t.st3{fill:url(#SVGID_00000016071054413884101900000006311783192816897448_);}\r\n\t.st4{fill:url(#SVGID_00000180329505159379697920000017936263794209143949_);}\r\n\t.st5{fill:url(#SVGID_00000173146953566610232460000002978387981359732408_);}\r\n\t.st6{fill:url(#SVGID_00000183928710781954103420000013257286392271628974_);}\r\n\t.st7{fill:url(#SVGID_00000124859292141213684620000001047600495310285213_);}\r\n\t.st8{fill:url(#SVGID_00000145756754568093088240000008497602286313211578_);}\r\n\t.st9{fill:url(#SVGID_00000156578701531795095420000013861785772114314172_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "262.45,244.53 273.31,244.53 273.31,225.28 280.88,225.28 280.88,217.5 254.77,217.5 254.77,225.28  262.45,225.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "288.87,244.53 294.4,228.35 299.93,244.53 310.48,244.53 300.13,217.5 288.67,217.5 278.32,244.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "315.49,244.53 326.35,244.53 326.35,225.28 334.03,225.28 334.03,217.5 307.92,217.5 307.92,225.28  315.49,225.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "341.91,244.53 347.44,228.35 352.97,244.53 363.52,244.53 353.18,217.5 341.71,217.5 331.37,244.53  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M445.64,263.88c1.33,3.07,3.07,6.35,4.81,9.32l7.07,11.88h5.12v-27.03h-4.61v9.42c0,4.1,0.1,7.58,0.41,11.16 h-0.1c-1.23-2.97-2.87-6.04-4.61-9.11l-6.96-11.57h-5.63v27.03h4.61v-9.52c0-4.4-0.1-7.99-0.31-11.57H445.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.07,277.5h8.6l2.46,7.68h5.32l-8.81-27.03h-6.25l-8.7,27.03h5.12L421.07,277.5z M423.94,267.06 c0.51-1.64,0.92-3.48,1.33-5.12h0.1c0.41,1.54,0.82,3.38,1.33,5.12l2.15,6.66h-6.96L423.94,267.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.58,281.5c-2.56,0-4.92-0.82-6.55-1.74l-1.13,4.1c1.43,0.92,4.4,1.74,7.27,1.74 c6.96,0,10.24-3.79,10.24-8.09c0-3.89-2.25-6.25-6.96-8.09c-3.58-1.33-5.22-2.36-5.22-4.4c0-1.64,1.33-3.28,4.51-3.28 c2.56,0,4.4,0.82,5.43,1.33l1.23-3.99c-1.43-0.72-3.58-1.33-6.45-1.33c-5.84,0-9.63,3.38-9.63,7.78c0,3.89,2.87,6.25,7.37,7.88 c3.38,1.23,4.81,2.46,4.81,4.51C345.5,279.96,343.65,281.5,340.58,281.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.52,261.73c2.25,0,3.99,0.51,5.22,1.02l1.02-3.89c-1.02-0.51-3.28-1.23-6.55-1.23 c-8.29,0-14.44,5.32-14.44,14.23c0,8.19,5.22,13.62,13.82,13.62c3.28,0,5.84-0.61,7.07-1.23l-0.82-3.89 c-1.33,0.61-3.38,1.02-5.43,1.02c-5.94,0-9.42-3.79-9.42-9.73C259.99,265.11,263.99,261.73,269.52,261.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "407.65,285.08 407.65,262.25 415.44,262.25 415.44,258.05 394.96,258.05 394.96,262.25  402.74,262.25 402.74,285.08  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M506.47,258.05l-3.28,6.96c-0.92,1.95-1.64,3.69-2.36,5.32h-0.1c-0.72-1.84-1.43-3.38-2.36-5.32l-3.17-6.96 h-5.73l8.6,15.77v11.26h4.92v-11.37l9.01-15.67H506.47L506.47,258.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.2,257.64c-7.68,0-12.9,5.84-12.9,14.13c0,7.88,4.81,13.72,12.49,13.72l0,0c7.37,0,12.9-5.22,12.9-14.23 C302.69,263.58,298.09,257.64,290.2,257.64z M290,281.6L290,281.6c-4.81,0-7.58-4.51-7.48-9.93c0-5.43,2.56-10.14,7.58-10.14 c4.92,0,7.48,4.81,7.48,9.93C297.47,277.2,294.71,281.6,290,281.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.59,261.73c2.25,0,3.99,0.51,5.22,1.02l1.02-3.89c-1.02-0.51-3.28-1.23-6.55-1.23 c-8.29,0-14.44,5.32-14.44,14.23c0,8.19,5.22,13.62,13.82,13.62c3.28,0,5.84-0.61,7.07-1.23l-0.82-3.89 c-1.33,0.61-3.38,1.02-5.43,1.02c-5.94,0-9.42-3.79-9.42-9.73C472.06,265.11,476.06,261.73,481.59,261.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "386.56,258.05 381.64,258.05 381.64,285.08 397.72,285.08 397.72,280.99 386.56,280.99  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.01,273.51v-15.46h-4.92v15.77c0,5.32-2.15,7.78-5.73,7.78c-3.38,0-5.53-2.46-5.53-7.78v-15.77h-4.92 v15.46c0,8.5,4.1,11.98,10.34,11.98C371.71,285.59,376.01,281.8,376.01,273.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.4,258.05h-4.61v9.42c0,4.1,0.1,7.58,0.41,11.16h-0.1c-1.23-2.97-2.87-6.04-4.61-9.11l-6.96-11.57h-5.63 v27.03h4.61v-9.52c0-4.4-0.1-7.99-0.31-11.57h0.1c1.33,3.07,3.07,6.35,4.81,9.32l7.07,11.88h5.12L328.4,258.05L328.4,258.05z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.58,
    y: 298.6,
    className: "st0",
    width: 4.92,
    height: 27.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.68,313.04v-0.1c2.56-0.92,4.92-3.28,4.92-6.66c0-2.25-0.82-4.2-2.36-5.43 c-1.84-1.54-4.92-2.15-8.29-2.15c-3.38,0-5.53,0.2-7.48,0.61v26.52h4.92v-11.06h2.46c2.76,0.1,4.1,1.23,4.81,4.71 c0.72,3.38,1.43,5.53,1.84,6.35h5.02c-0.51-1.02-1.23-4.1-2.15-7.48C313.75,315.6,312.63,313.75,310.68,313.04z M305.25,311.09 h-2.87v-8.5c0.51-0.1,1.54-0.2,3.07-0.2c3.17,0,5.22,1.33,5.22,4.3C310.68,309.35,308.63,311.09,305.25,311.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.49,310.99c-1.02,3.28-2.05,6.55-2.76,9.73h-0.1c-0.72-3.28-1.64-6.45-2.66-9.83l-3.69-12.29h-5.43 l8.7,27.03h5.63l9.32-27.03h-5.22L332.49,310.99z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "383.8,313.65 393.93,313.65 393.93,309.66 383.8,309.66 383.8,302.69 394.55,302.69 394.55,298.6  378.78,298.6 378.78,325.73 395.16,325.73 395.16,321.64 383.8,321.64  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.54,302.28c2.25,0,3.99,0.51,5.22,1.02l1.02-3.89c-1.02-0.51-3.28-1.23-6.55-1.23 c-8.29,0-14.44,5.32-14.44,14.23c0,8.19,5.22,13.62,13.82,13.62c3.28,0,5.84-0.61,7.07-1.23l-0.82-3.89 c-1.33,0.61-3.38,1.02-5.43,1.02c-5.94,0-9.42-3.79-9.42-9.73C359.01,305.77,363.01,302.28,368.54,302.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.42,309.96c-3.58-1.33-5.22-2.36-5.22-4.4c0-1.64,1.33-3.28,4.51-3.28c2.56,0,4.4,0.82,5.43,1.33 l1.23-3.99c-1.43-0.72-3.58-1.33-6.45-1.33c-5.84,0-9.63,3.38-9.63,7.78c0,3.89,2.87,6.25,7.37,7.88 c3.38,1.23,4.81,2.46,4.81,4.51c0,2.25-1.74,3.69-4.92,3.69c-2.56,0-4.92-0.82-6.55-1.74l-1.13,4.1c1.43,0.92,4.4,1.74,7.27,1.74 c6.96,0,10.24-3.79,10.24-8.09C272.38,314.06,270.13,311.71,265.42,309.96z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "281.8,313.65 291.94,313.65 291.94,309.66 281.8,309.66 281.8,302.69 292.56,302.69 292.56,298.6  276.79,298.6 276.79,325.73 293.17,325.73 293.17,321.64 281.8,321.64  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.88,309.96c-3.58-1.33-5.22-2.36-5.22-4.4c0-1.64,1.33-3.28,4.51-3.28c2.56,0,4.4,0.82,5.43,1.33 l1.23-3.99c-1.43-0.72-3.58-1.33-6.45-1.33c-5.84,0-9.63,3.38-9.63,7.78c0,3.89,2.87,6.25,7.37,7.88 c3.38,1.23,4.81,2.46,4.81,4.51c0,2.25-1.74,3.69-4.92,3.69c-2.56,0-4.92-0.82-6.55-1.74l-1.13,4.1c1.43,0.92,4.4,1.74,7.27,1.74 c6.96,0,10.24-3.79,10.24-8.09C415.85,314.06,413.59,311.71,408.88,309.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.7792,
    y1: 320.8445,
    x2: 9.7792,
    y2: 361.2769,
    gradientTransform: "matrix(1 0 0 1 0 -130.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    style: {
      stopColor: "#F05731"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05731"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,236.03c0-12.29,7.99-19.56,19.56-19.56v-20.89c0-6.14-4.1-10.24-9.83-10.24S0,189.44,0,195.58V236.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045607463329277205040000015435953279712727981_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.0474,
    y1: 351.9165,
    x2: 21.474,
    y2: 428.418,
    gradientTransform: "matrix(1 0 0 1 0 -130.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F80000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3984"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045607463329277205040000015435953279712727981_)"
    },
    d: "M34.71,326.45 c4.92,0,9.42-0.82,13.52-2.25c-20.58,3.48-28.57-10.65-28.57-26.52v-65.33h23.86c5.53,0,9.22-3.28,9.22-7.99 c0-4.71-3.69-7.99-9.22-7.99H19.56C7.99,216.37,0,223.74,0,236.03v56.12C0,314.57,12.9,326.45,34.71,326.45z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169523109871976117330000004714455752638692230_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.3469,
    y1: 442.4073,
    x2: 72.7036,
    y2: 424.8421,
    gradientTransform: "matrix(1 0 0 1 0 -130.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE3984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    style: {
      stopColor: "#7800DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7800DA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169523109871976117330000004714455752638692230_)"
    },
    d: "M48.23,324.2 c8.19-3.07,14.54-8.81,18.53-17.2l-9.22-16.59c-4.1,12.29-11.26,18.84-20.99,18.84c-10.24,0-17-5.94-17-19.35v7.78 C19.56,313.55,27.55,327.68,48.23,324.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179641237048363074910000015698953506686848143_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.5726,
    y1: 373.148,
    x2: 112.799,
    y2: 444.4731,
    gradientTransform: "matrix(1 0 0 1 0 -130.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#EE3984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3984"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179641237048363074910000015698953506686848143_)"
    },
    d: "M132.1,320.92 C85.5,327.88,70.86,303,70.86,270.85c0-23.24,14.34-39.22,34.92-39.22c7.58,0,13.93,1.64,19.56,4.3c2.66,1.23,4.92,1.64,6.96,1.64 c4.92,0,8.19-3.28,8.19-8.19c0-3.07-1.84-6.14-6.14-8.19c-7.78-3.89-17.82-6.14-28.57-6.14c-32.26,0.1-54.58,23.04-54.58,56.32 c0,32.67,21.4,55.3,55.91,55.3C116.63,326.66,124.72,324.81,132.1,320.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013160954061189181280000014232579474532276414_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.3024,
    y1: 373.4126,
    x2: 140.4928,
    y2: 373.4126,
    gradientTransform: "matrix(1 0 0 1 0 -130.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3B00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013160954061189181280000014232579474532276414_)"
    },
    d: "M51.3,271.36 c0-33.28,22.22-56.12,54.48-56.12c10.85,0,20.79,2.25,28.57,6.14c4.3,2.05,6.14,5.12,6.14,8.19c0,4.92-3.28,8.19-8.19,8.19 c-2.05,0-4.3-0.41-6.96-1.64c-6.96-3.28-13.72-4.3-19.56-4.3C77.41,231.73,51.3,249.65,51.3,271.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129896612903594115750000003944903459341558945_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.5583,
    y1: 399.7806,
    x2: 225.2031,
    y2: 399.7806,
    gradientTransform: "matrix(1 0 0 1 0 -130.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3984"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129896612903594115750000003944903459341558945_)"
    },
    d: "M173.16,221.7 c-1.84,1.84-2.87,4.1-2.87,6.76c0,6.76,6.35,16.79,20.99,26.93l16.79,11.67c12.29,8.6,17.2,16.79,17.2,28.98 c0,8.81-3.48,16.38-9.22,21.61c2.05-1.84,3.28-4.3,3.28-7.58c0-7.17-7.17-18.33-22.43-28.98l-15.36-10.65 c-12.9-9.01-17.92-17.31-17.92-28.77c0-6.76,2.46-12.9,6.55-17.31C171.11,223.33,172.13,222.52,173.16,221.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169559552864074530310000016613102261869766030_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.3164,
    y1: 429.5544,
    x2: 159.0242,
    y2: 443.9259,
    gradientTransform: "matrix(1 0 0 1 0 -130.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE3984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7800DA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169559552864074530310000016613102261869766030_)"
    },
    d: "M159.95,313.34 c0,3.28,1.64,5.94,5.94,7.99c5.94,2.87,15.56,5.32,24.06,5.32c10.85,0,19.76-3.28,26.11-9.01c2.05-1.84,3.28-4.3,3.28-7.58 c0-7.17-7.17-18.33-22.43-28.98c6.96,4.92,9.83,9.01,9.83,14.95c0,8.81-6.96,14.75-17,14.75c-9.63,0-17.82-4.92-22.22-4.92 C162.92,305.87,159.95,308.94,159.95,313.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164505031511736905850000004295770396734750140_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.3057,
    y1: 365.323,
    x2: 222.1788,
    y2: 365.323,
    gradientTransform: "matrix(1 0 0 1 0 -130.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05731"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05731"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164505031511736905850000004295770396734750140_)"
    },
    d: "M191.39,255.39 c-6.55-4.71-9.42-9.01-9.42-14.13c0-6.55,5.32-10.65,12.9-10.65c9.63,0,14.13,4.51,19.76,4.51c4.51,0,7.58-3.07,7.58-7.58 c0-3.28-1.64-5.94-5.94-7.99c-6.76-3.28-14.13-4.51-22.02-4.51c-8.4,0-15.77,2.46-20.99,6.55c-1.84,1.84-2.87,4.1-2.87,6.76 C170.29,235.21,176.64,245.15,191.39,255.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170269249219997360370000016560782916333249707_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.3377,
    y1: 431.7043,
    x2: 140.1294,
    y2: 369.9604,
    gradientTransform: "matrix(1 0 0 1 0 -130.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE3984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7800DA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170269249219997360370000016560782916333249707_)"
    },
    d: "M70.86,270.95 c0,32.05,14.75,56.93,61.24,50.07c14.95-7.78,25.5-23.45,32.87-47.62l4.3-14.13c-4.1-5.32-5.73-11.26-5.73-17.61 c0-6.76,2.46-12.9,6.55-17.31c-6.14,6.55-11.26,16.18-15.36,29.59l-4.71,15.56c-8.4,27.34-21.61,40.45-42.29,40.45 C85.2,309.86,70.86,294.2,70.86,270.95z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcsLogo);
export default __webpack_public_path__ + "static/media/TCS-logo.108dcf6d04f6dfe6ed024ae4a5d9972a.svg";
export { ForwardRef as ReactComponent };